import React from 'react';
import MetaData from '../../layouts/MetaData';
import HRSidebar from '../../components/HR/HRSidebar';
import HRTopBar from '../../components/HR/HRTopbar';
import TelemetryReportView from '../../components/Telemetry/TelemetryReportView';

const TelemetryReportNurse = () => (
    <>
        <MetaData title="Telemetry Report" />
        <HRSidebar />
        <section className="home-section">
            <HRTopBar />
            <div className="shadow-lg p-3 mb-5 mr-4 ml-4 bg-white rounded">
                <div className="home-content">
                    <TelemetryReportView idPrefix="nurse" />
                </div>
            </div>
        </section>
    </>
);

export default TelemetryReportNurse;
